var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTradingBots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2135_3002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.9883,
    r: 40,
    fill: "#3094B4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9246 43.4076H31.8809C29.3712 43.4076 26.9642 42.4082 25.1896 40.6293C23.415 38.8505 22.418 36.4378 22.418 33.9221C22.418 31.4063 23.415 28.9937 25.1896 27.2148C26.9642 25.4359 29.3712 24.4365 31.8809 24.4365H43.9246C46.4343 24.4365 48.8412 25.4359 50.6159 27.2148C52.3905 28.9937 53.3875 31.4063 53.3875 33.9221",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9269 39.9592H31.8832C30.2861 39.9592 28.7544 39.3233 27.6251 38.1912C26.4958 37.0592 25.8613 35.5239 25.8613 33.923C25.8613 32.3221 26.4958 30.7867 27.6251 29.6547C28.7544 28.5227 30.2861 27.8867 31.8832 27.8867H43.9269C44.7177 27.8867 45.5008 28.0429 46.2314 28.3462C46.962 28.6496 47.6258 29.0942 48.185 29.6547C48.7442 30.2152 49.1877 30.8806 49.4904 31.613C49.793 32.3453 49.9488 33.1303 49.9488 33.923",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9621 34.6511C45.5776 34.6511 46.0765 34.026 46.0765 33.2548C46.0765 32.4836 45.5776 31.8584 44.9621 31.8584C44.3466 31.8584 43.8477 32.4836 43.8477 33.2548C43.8477 34.026 44.3466 34.6511 44.9621 34.6511Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.841 34.6511C31.4565 34.6511 31.9554 34.026 31.9554 33.2548C31.9554 32.4836 31.4565 31.8584 30.841 31.8584C30.2255 31.8584 29.7266 32.4836 29.7266 33.2548C29.7266 34.026 30.2255 34.6511 30.841 34.6511Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1914 34.0762C34.634 34.6393 35.1982 35.0945 35.8417 35.4075C36.4851 35.7204 37.191 35.883 37.9062 35.883C38.6214 35.883 39.3273 35.7204 39.9707 35.4075C40.6141 35.0945 41.1784 34.6393 41.621 34.0762",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9195 44.3201C62.479 40.0712 59.4964 36.1721 55.2576 35.6113C51.0189 35.0505 47.1292 38.0403 46.5697 42.2891C46.0102 46.538 48.9928 50.4371 53.2316 50.9979C57.4703 51.5587 61.3601 48.5689 61.9195 44.3201Z",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2367 50.0195L47.3691 55.1935",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9004 20.9883V24.4376",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7193 54.6194H45.0447C45.8367 54.6032 46.6052 54.8892 47.195 55.4193C47.7847 55.9494 48.1517 56.6842 48.2217 57.4752C48.2437 57.8846 48.1822 58.2942 48.041 58.679C47.8999 59.0639 47.6819 59.4158 47.4006 59.7134C47.1192 60.0111 46.7803 60.2481 46.4046 60.4101C46.0288 60.5721 45.624 60.6556 45.215 60.6556H26.7193C26.1544 60.6556 25.5951 60.5441 25.0732 60.3274C24.5514 60.1107 24.0772 59.7931 23.6778 59.3928C22.8711 58.5842 22.418 57.4875 22.418 56.344V47.7208C22.418 46.5773 22.8711 45.4806 23.6778 44.672C24.4845 43.8634 25.5785 43.4092 26.7193 43.4092H35.3219",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3255 46.8574H28.4434V50.3067H35.3255V46.8574Z",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.209 54.6191V60.6554",
    stroke: "#F9F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1089 39.9918H55.8262C56.7266 39.9918 57.4565 40.7245 57.4565 41.6282C57.4565 42.532 56.7266 43.2646 55.8262 43.2646M53.1089 39.9918V43.2646M53.1089 39.9918H51.4785M53.1089 39.9918V38.3555M55.8262 43.2646H53.1089M55.8262 43.2646C56.7266 43.2646 57.4565 43.9972 57.4565 44.9009C57.4565 45.8047 56.7266 46.5373 55.8262 46.5373H53.1089M53.1089 43.2646V46.5373M53.1089 46.5373H51.4785M53.1089 46.5373V48.1737M54.7393 39.9918V38.3555M54.7393 48.1737V46.5373",
    stroke: "#F9F9F9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2135_3002",
    x: 0,
    y: 0.988281,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113333 0 0 0 0 0.432533 0 0 0 0 0.533333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2135_3002"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradingBots);
export default __webpack_public_path__ + "static/media/trading-bots.52a2b13bc7abc6ca1968746fc272b66e.svg";
export { ForwardRef as ReactComponent };